module.exports = __webpack_public_path__ + "static/media/reset-password.4f597db6.png";